import { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";

// @material-ui/core components
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormGroup,
  FormLabel,
  Grid,
  LinearProgress,
  Select,
  MenuItem,
  FormControl,
  TextField,
  Typography,
} from "@material-ui/core";

import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import moment from "moment";
import MaskAndValid from "utils/maskAndValid";
import Api from "lib/api/httpRequestHelper";
import UtilsFncs from "utils/UtilsFncs";

import DateField from "components/_refactor/fields/date";

const today = moment().format("DD/MM/YYYY");

const typeList = [
  {
    id: 1,
    name: "Entrada Existente",
    value: "ENTRADA_EXISTENTE",
  },
  {
    id: 2,
    name: "NF Devolvida",
    value: "NF_DEVOLVIDA",
  },
  {
    id: 3,
    name: "NF Extraviada",
    value: "NF_EXTRAVIADA",
  },
  {
    id: 4,
    name: "Outros",
    value: "OUTROS",
  },
];

function DialogRegistroDeNota({ open, formType, onClose, selectedReason }) {
  const snackbar = useSnackbar();
  const userDetail = JSON.parse(localStorage.getItem("userDetail"));
  const userDetailVision = JSON.parse(localStorage.getItem("userDetailVision"));
  const user = userDetailVision ? userDetailVision?.Nome : userDetail?.Nome;

  const [submitting, setSubmitting] = useState(false);
  const [observation, setObservation] = useState("");
  const [occurenceDate, setOccuranceDate] = useState(today);
  const [numberNF, setNumberNF] = useState("");
  const [type, setType] = useState(typeList[0]?.value);
  const [hasChange, setHasChange] = useState(false);
  const [userName, setUserName] = useState(user);

  const handleClose = (closing) => {
    onClose(closing);
  };

  const submit = async () => {
    setSubmitting(true);

    if (formType === "edit") {
      await Api.put(
        "edit-invoice-ocurrence",
        "invoice",
        {
          idOcorrenciaEntradaDevolucao:
            selectedReason?.NotaManual?.IdOcorrenciaEntradaDevolucao?.toString(),
          tipo: type,
          numeroNfDevolucao: numberNF?.toString(),
          dataOcorrencia: UtilsFncs.ConvertDateFormat(occurenceDate, "/", "-"),
          observacao: observation,
        },
        true
      )
        .then((res) => {
          if (res.Success) {
            snackbar.showMessage(`Nota editada com sucesso!`, {
              severity: "success",
            });
            handleClose({ type: "creating" });
          }
        })
        .catch((error) => {
          console.log(error);
          snackbar.showMessage(error, {
            severity: "error",
          });        })
        .finally(() => setSubmitting(false));
    } else {
      await Api.post(
        "create-invoice-ocurrence",
        "invoice",
        {
          tipo: type,
          dataOcorrencia: UtilsFncs.ConvertDateFormat(occurenceDate, "/", "-"),
          serie: selectedReason?.SerieNf,
          numeroNf: selectedReason?.NumeroNf.toString(),
          observacao: observation,
          numeroNfDevolucao: numberNF,
        },
        true
      )
        .then((res) => {
          if (res.Success) {
            snackbar.showMessage(`Nota registrada com sucesso!`, {
              severity: "success",
            });
            handleClose({ type: "creating" });
          }
        })
        .catch((error) => {
          console.log(error);
          snackbar.showMessage(error, {
            severity: "error",
          });        })
        .finally(() => setSubmitting(false));
    }
  };

  useEffect(() => {
    if (selectedReason?.NotaManual?.NumeroNF) {
      setType(selectedReason?.NotaManual?.Tipo);
      setNumberNF(selectedReason?.NotaManual?.NumeroNFDevolucao);
      setOccuranceDate(selectedReason?.NotaManual?.DataOcorrenciaFormat);
      setObservation(selectedReason?.NotaManual?.Observacao);
      setUserName(selectedReason?.NotaManual?.Usuario);
    }
  }, []);

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
      >
        <DialogTitle>
          <span>
            <Typography id="alert-dialog-title" variant="h3" component="h3">
              {`${
                selectedReason?.NotaManual?.NumeroNF ? "Editar" : "Registrar"
              } Entrada de Nota Fiscal`}
            </Typography>
          </span>
        </DialogTitle>
        <PerfectScrollbar>
          <DialogContent style={{ padding: "1.5rem" }}>
            <>
              <Grid container>
                <Grid item xs={12}>
                  <FormGroup>
                    <FormLabel required>Motivo</FormLabel>
                    <FormControl variant="outlined" fullWidth>
                      <Select
                        defaultValue={type}
                        name="tipoExportacao"
                        value={type}
                        onChange={(e) => {
                          setHasChange(true);
                          setType(e.target.value);
                          if (e.target.value === "ENTRADA_EXISTENTE") {
                            setNumberNF("");
                          }
                        }}
                      >
                        {typeList?.map((option) => (
                          <MenuItem key={option?.id} value={option?.value}>
                            {option?.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </FormGroup>
                </Grid>
                <Grid item xs={12} hidden={type === "ENTRADA_EXISTENTE"}>
                  <FormGroup>
                    <FormLabel required>Número da NF de Devolução</FormLabel>
                    <TextField
                      name="numeroNF"
                      type="text"
                      onChange={(event) => setNumberNF(event.target.value)}
                      fullWidth
                      disabled={submitting}
                      value={numberNF}
                      variant="outlined"
                      inputProps={{ min: 0 }}
                      onInput={(e) => {
                        setHasChange(true);
                        e.target.value = e.target.value.toString().slice(0, 50);
                      }}
                    />
                  </FormGroup>
                </Grid>
                <Grid item xs={12}>
                  <FormGroup>
                    <DateField
                      label="Data da Ocorrência"
                      value={occurenceDate}
                      onChange={(newValue) => {
                        setHasChange(true);
                        setOccuranceDate(newValue);
                      }}
                      disabled={submitting}
                      required
                    />
                  </FormGroup>
                </Grid>
                <Grid item xs={12}>
                  <FormGroup>
                    <FormLabel required>Observação</FormLabel>
                    <TextField
                      placeholder="Observação"
                      multiline
                      required
                      rows={3}
                      value={observation}
                      onChange={(event) => setObservation(event.target.value)}
                      variant="outlined"
                      disabled={submitting}
                      onInput={(e) => {
                        setHasChange(true);
                        e.target.value = e.target.value
                          .toString()
                          .slice(0, 4000);
                      }}
                    />
                  </FormGroup>
                </Grid>
                <Grid item xs={12}>
                  <FormGroup>
                    <FormLabel>Usuário</FormLabel>
                    <TextField
                      name="usuario"
                      type="text"
                      fullWidth
                      disabled={true}
                      value={userName}
                      variant="outlined"
                    />
                  </FormGroup>
                </Grid>
              </Grid>
            </>
            {submitting && (
              <div style={{ marginTop: "1rem" }}>
                <span>{`${
                  formType === "create" ? "Cadastrando" : "Editando"
                } entrada de nota fiscal...`}</span>
                <LinearProgress />
              </div>
            )}
          </DialogContent>
        </PerfectScrollbar>
        <DialogActions>
          <Button
            component={Box}
            onClick={() => {
              setHasChange(false);
              handleClose({ type: "cancel" });
            }}
            disabled={submitting}
          >
            Cancelar
          </Button>
          <Button
            color="default"
            variant="contained"
            type="button"
            onClick={submit}
            disabled={
              !hasChange ||
              submitting ||
              MaskAndValid.isNullOrEmpty(observation) ||
              MaskAndValid.isNullOrEmpty(type) ||
              MaskAndValid.isNullOrEmpty(occurenceDate) ||
              (type !== "ENTRADA_EXISTENTE" &&
                MaskAndValid.isNullOrEmpty(numberNF))
            }
          >
            {formType === "edit" ? "Atualizar" : "Cadastrar"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export { DialogRegistroDeNota };
